import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import { Link } from 'preact-router/match';

import store from '../store'

export default class Footer extends Component {
  render(props){
    return(
        <footer id="footer">
        <div class="main">
          <div class="container">
            <div class="row">
              <div class="col about">
                <Link href={props.prefix+"/company"}><div class="label"><Text id="footer.menu.about"/></div></Link>
                <p><Text id="footer.menu.desc"/></p>
                <ul class="social-networks clearfix">
                  <li><a href="https://www.facebook.com/DolphNet.internet/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xlinkhref="/assets/img/icons.svg#facebook"></use></svg></a></li>
                  <li><a href="https://twitter.com/dolphneti" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" class="icon"><use xlinkhref="/assets/img/icons.svg#twitter"></use></svg></a></li>
                </ul>
              </div>
              <div class="col contacts">
                <div class="label"><Text id="footer.menu.support"/></div>
                <ul>
                  <li><a href="tel:+37169999999">+371-69-999-999</a></li>
                  <li><Link href={props.prefix+"/contact?form=true"} class="subscription"><Text id="footer.menu.link"/></Link></li>
                </ul>
                <div class="label"><Text id="footer.menu.adres"/></div>
                <ul>
                  <li><span class="address"><Text id="footer.menu.adresText"/></span></li>
                  <li><a href="https://www.google.com/maps/place/DolphNet+internet/@56.9600007,24.0994507,17z/data=!3m1!4b1!4m5!3m4!1s0x46eecff6118e503d:0x59fce2c684aaab3a!8m2!3d56.9600007!4d24.1016394" target="_blank" class="location"><Text id="footer.menu.map"/></a></li>
                </ul>
              </div>
              <div class="col">
                <div class="label"><Text id="footer.menu.services.label"/></div>
                <ul class="menu">
                  <li><Link href={props.prefix+"/internet"}><Text id="footer.menu.services.item"/></Link></li>
                  <li><Link href={props.prefix+"/telephone"}><Text id="footer.menu.services.item2"/></Link></li>
                  <li><Link href={props.prefix+"/email"}><Text id="footer.menu.services.item3"/></Link></li>
                  <li><Link href={props.prefix+"/hosting"}><Text id="footer.menu.services.item4"/></Link></li>
                  <li><Link href={props.prefix+"/services"}><Text id="footer.menu.services.item5"/></Link></li>
                </ul>
              </div>
              <div class="col">
                <div class="label"><Text id="footer.menu.site.label"/></div>
                <ul class="menu">
                  <li><Link href={props.prefix+"/availability"}><Text id="footer.menu.site.item"/></Link></li>
                  <li><a href="javascript:"  onClick={()=>store.showModal('login')} ><Text id="footer.menu.site.item2"/></a></li>
                  <li><Link href={props.prefix+"/support"}><Text id="footer.menu.site.item3"/></Link></li>
                  {/*
                  TODO: write footer

                  <li><Link href={props.prefix+"/faq"}><Text id="footer.menu.site.item4"/></Link></li>*/}
                  <li><Link href={props.prefix+"/privacy"}><Text id="footer.menu.site.item5"/></Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="container">
            <div class="copyright"><Text id="footer.copy"/></div>
            <div class="desing-marketing"> <Text id="footer.note"/><a href="https://www.alc.lv/" target="_blank"><Text id="footer.noteLink"/></a></div>
          </div>
        </div>
      </footer>
)
}}



// WEBPACK FOOTER //
// ./components/footer.js